<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <b-row>
          <b-col cols="6">
            <span v-if="isUpdateForm">{{ $t('ai_job.update_title') }}</span>
            <span v-else>{{ $t('ai_job.create_title') }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="spinners.contentIsLoading" class="text-center">
        <b-spinner type="grow" variant="primary"/>
      </div>
      <div v-else>
        <b-form-group :invalid-feedback="fErr('name')">
          <label>{{ $t('ai_job.name') }}</label>
          <b-form-input type="text" :placeholder="$t('ai_job.name_placeholder')"
            :class="{ 'is-invalid' : fErr('name') }"
            v-model="entity.name"/>
        </b-form-group>
        <b-form-group :invalid-feedback="fErr('config')">
          <label>{{ $t('ai_job.config') }}</label>
          <b-form-textarea type="text" :placeholder="$t('ai_job.config_placeholder')"
            :class="{ 'is-invalid' : fErr('config') }"
            rows="3" max-rows="6" disabled
            :value="JSON.stringify(config)"/>
        </b-form-group>

        <b-form-group :label="$t('ai_job.label_set_id')">
          <treeselect :class="{ 'treeselect-error' : fErr('label_set_id') }"
            :placeholder="$t('ai_job.placeholders.label_set_id')"
            :load-options="audocompleteLabelSet" :async="true" :defaultOptions="true"
            v-model="entity.label_set_id"/>
          <span class="error-text">{{ fErr('label_set_id') }}</span>
        </b-form-group>
        <b-form-group :label="$t('ai_job.ai_model_id')">
          <treeselect :class="{ 'treeselect-error' : fErr('ai_model_id') }"
            :placeholder="$t('ai_job.placeholders.ai_model_id')"
            :load-options="audocompleteAiModel" :async="true" :defaultOptions="true"
            v-model="entity.ai_model_id"/>
          <span class="error-text">{{ fErr('ai_model_id') }}</span>
        </b-form-group>
        <AiJobTagPicker :modelLabels="modelLabels" @updated="mappingUpdated"/>
      </div>
      <div slot="footer">
        <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ $t('global.save') }}
        </b-button>
        <router-view :to="{ name: 'AiJobs' }">
          <b-button type="reset" variant="info" class="ml-2">
            {{ $t('global.cancel') }}
          </b-button>
        </router-view>
      </div>
    </b-card>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import { mapGetters, mapState } from 'vuex';
import AiJobTagPicker from '@/views/AiJobs/AiJobTagPicker';

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      config: {},
      errorMsg: this.errors,
      modelLabels: [],
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          name: '',
          // config: '',
          label_set_id: null,
          ai_model_id: null,
        };
      },
    },
  },
  components: {
    Treeselect, AiJobTagPicker
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isUpdateForm() { return this.id !== null; },
    ...mapState('Auth', ['activeProjectId']),
    projectId() { return this.project_id || this.activeProjectId; },
    // config: {
    //   get() {
    //     return this.entity.
    //   },
    //   set(value) {

    //   }
    // }
  },
  watch: {
    'entity.ai_model_id'(value) {
      // console.log(value);
      // if (!value) {
      this.config.labels = null;
      // } else {
      if (value) {
        Services.aiModels.editData(this.projectId, value).then(({ data }) => {
          // console.log(value, data);
          this.modelLabels = JSON.parse(data.aiModel.labels) || [];
        // this.config = { ...this.config };
        });
      }
      // }
    }
  },
  methods: {
    getForUpdate: Services.aiJobs.editData,
    getForCreate: Services.aiJobs.createData,
    pushUpdate: Services.aiJobs.update,
    pushCreate: Services.aiJobs.create,
    mappingUpdated(mapping) {
      this.config.labels = mapping;
      this.config = { ...this.config };
    },
    load() {
      this.spinners.contentIsLoading = true;
      const action = this.isUpdateForm ? this.getForUpdate : this.getForCreate;
      action(this.projectId, this.$route.params.id).then((data) => {
        this.spinners.contentIsLoading = false;
        this.entity = this.isUpdateForm ? data.data.aiJob : { ...this.entity, ...data.data.aiJob };
        this.config = this.isUpdateForm ? JSON.parse(data.data.aiJob.config) : { ...this.config, ...JSON.parse(data.data.aiJob.config) };
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      const action = this.isUpdateForm ? this.pushUpdate : this.pushCreate;
      action(this.projectId, { ...this.entity, project_id: this.projectId, config: JSON.stringify(this.config) }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.config = this.isUpdateForm ? JSON.parse(data.data.config) : { ...this.config, ...JSON.parse(data.data.config) };

        this.errorMsg = {};
        if (!this.isUpdateForm) {
          // After successful create
          // if (this.$can('edit', 'ai_jobs')) {
          this.$router.push({ name: 'AiJobs', params: { id: data.data.id } });
          // } else { // do not redirect if cannot edit
          //   this.entity = this.$options.props.value.default();
          //   this.load();
          // }
        }
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },

    audocompleteLabelSet({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.labelSets.list(this.projectId, { notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },
    audocompleteAiModel({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        Services.aiModels.list(this.projectId, { notpaginate: 1, search: searchQuery }).then(({ data }) => {
          const options = data.data.map((i) => ({
            id: i.id,
            label: `${i.id} ${i.name}`,
          }));
          callback(null, options);
        });
      }
    },

  }
};
</script>

<style scoped>
</style>
